import React, { useState } from 'react';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import { TestoPrivacy, VERSIONE_PRIVACY } from './Privacy';

// Mostrata una volta al login a chi non ha ancora preso visione della versione corrente
// dell'informativa privacy (stesso schema di InformativaCollaboratori). Presa visione, non consenso.
export default function AggiornamentoPrivacy() {
  const { user, updateUser, logout } = useAuth();
  const [letta, setLetta] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const conferma = async () => {
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/privacy/presa-visione');
      updateUser({ privacy_da_rivedere: false });
    } catch (err) {
      setError(err.response?.data?.error || 'Errore');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>INFORMATIVA PRIVACY AGGIORNATA</div>
        <p style={s.desc}>
          Ciao <strong style={{ color:'#F4600C' }}>{user?.nome}</strong>, abbiamo aggiornato l'informativa su come trattiamo i tuoi dati
          (versione {VERSIONE_PRIVACY.split('-').reverse().join('/')}). Leggila prima di continuare.
        </p>

        <div style={s.testo}><TestoPrivacy/></div>

        <label style={s.check}>
          <input type="checkbox" checked={letta} onChange={e=>setLetta(e.target.checked)} style={{ accentColor:'#F4600C', marginTop:'3px' }}/>
          <span>Dichiaro di aver letto l'informativa sul trattamento dei miei dati personali.</span>
        </label>
        {error && <div style={s.error}>{error}</div>}
        <button type="button" onClick={conferma} disabled={!letta || loading}
          style={{ ...s.btn, opacity: (!letta || loading) ? 0.5 : 1, cursor: !letta ? 'not-allowed' : 'pointer' }}>
          {loading ? 'REGISTRAZIONE...' : 'CONFERMO E CONTINUO'}
        </button>
        <div style={s.footer}>
          <button type="button" onClick={logout} style={s.linkBtn}>Esci</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:   { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px 16px' },
  card:   { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'16px', padding:'32px clamp(16px, 4vw, 32px)', width:'100%', maxWidth:'760px', boxSizing:'border-box' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'20px' },
  desc:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'16px', lineHeight:'1.6', textAlign:'center' },
  testo:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'16px 20px', maxHeight:'50vh', overflowY:'auto', marginBottom:'16px' },
  check:  { display:'flex', alignItems:'flex-start', gap:'8px', fontSize:'var(--font-size-sm)', marginBottom:'14px', cursor:'pointer' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600', marginBottom:'12px' },
  btn:    { width:'100%', background:'#C24B08', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', letterSpacing:'1px' },
  footer: { textAlign:'center', marginTop:'16px' },
  linkBtn:{ background:'none', border:'none', color:'#F4600C', fontWeight:'700', cursor:'pointer', fontSize:'var(--font-size-sm)' },
};
